import { render } from "./Loader.vue?vue&type=template&id=f9ba6f9e&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=f9ba6f9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ba6f9e"],['__file',"src/common/components/Loader/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9ba6f9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9ba6f9e', __exports__)) {
    api.reload('f9ba6f9e', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=f9ba6f9e&scoped=true", () => {
    api.rerender('f9ba6f9e', render)
  })

}


export default __exports__